/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { useSyncExternalStore } from 'fierry/react';


const QUERY = '(prefers-color-scheme: light)';


const subscribe = (callback) =>
{
  const mediaQuery = window.matchMedia(QUERY);

  mediaQuery.addEventListener('change', callback);

  return () => mediaQuery.removeEventListener('change', callback);
};


const getSnapshot = () =>
{
  return window.matchMedia(QUERY).matches ? 'light' : 'dark';
};


const useSystemAppearance = () =>
{
  return useSyncExternalStore(subscribe, getSnapshot);
};


export default useSystemAppearance;
